export const DefaultSlideWidth = 307;
export const HotelSlideWidth = 317;
export const StoreRgSlideWidth = 183;
export const StoreSmSlideWidth = 80;
export const TileSlideWidth = 171;
export const HotelExclusiveOfferSlideWidth = 200;

const Spacing = {
  XS: {
    Space: 'var(--spacing-xs)',
    Per: 32
  },
  XXXS: {
    Space: 'var(--spacing-xxxs)',
    Per: 16
  }
}

export const SlideGapByWidth = {
  [DefaultSlideWidth]: Spacing.XS.Space,
  [HotelSlideWidth]: Spacing.XXXS.Space,
  [StoreRgSlideWidth]: Spacing.XXXS.Space,
  [TileSlideWidth]: Spacing.XS.Space,
  [HotelExclusiveOfferSlideWidth]: Spacing.XXXS.Space,
}

export const SlidePerByWidth = {
  [DefaultSlideWidth]: Spacing.XS.Per,
  [HotelSlideWidth]: Spacing.XXXS.Per,
  [StoreRgSlideWidth]: Spacing.XXXS.Per,
  [TileSlideWidth]: Spacing.XS.Per,
  [HotelExclusiveOfferSlideWidth]: Spacing.XXXS.Per,
}
